import ReactPlayer from 'react-player';

const VideoWebM = ({ block }) => {
  if (!block) return '';
  return (
    <>
      <div className="player-wrapper">
        <ReactPlayer
          className="react-player"
          url={block.primary.video.url}
          playing={block.primary.autoplay}
          width={block.primary.width}
          height={block.primary.height}
          controls
          muted={block.primary.autoplay}
          loop={block.primary.loop}
        />
      </div>
      <style>{`
        .player-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default VideoWebM;
